function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2410 4523 l-1 -598 -524 -367 -524 -368 -681 0 -680 0 0 -1595 0 -1595 2560 0 2560 0 0 1595 0 1595 -680 0 -680 0 -524 368 -525 367 0 128 -1 127 425 0 425 0 0 470 0 470 -575 0 -575 0 0 -597z m850 127 l0 -170 -275 0 -275 0 0 170 0 170 275 0 275 0 0 -170z m-192 -1340 l491 -345 1 -417 0 -418 630 0 630 0 0 -915 0 -915 -759 0 -760 0 -3 388 -3 387 -27 80 c-36 106 -89 194 -167 277 -180 192 -435 274 -689 222 -149 -31 -264 -94 -377 -208 -91 -92 -143 -176 -183 -291 l-27 -80 -3 -387 -3 -388 -759 0 -760 0 0 915 0 915 630 0 630 0 0 418 1 417 492 347 c271 191 499 346 508 345 9 -1 237 -157 507 -347z m-1808 -650 l0 -230 -480 0 -480 0 0 230 0 230 480 0 480 0 0 -230z m3560 0 l0 -230 -480 0 -480 0 0 230 0 230 480 0 480 0 0 -230z m-2168 -1301 c131 -28 249 -121 309 -244 l34 -70 3 -372 3 -373 -441 0 -441 0 3 373 3 372 34 70 c91 186 293 286 493 244z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2418 2961 c-198 -64 -338 -253 -338 -457 0 -113 55 -251 133 -332 185 -193 509 -193 694 0 78 81 133 219 133 332 0 153 -84 310 -212 396 -117 78 -281 102 -410 61z m209 -292 c61 -23 112 -100 113 -168 0 -46 -33 -112 -69 -138 -131 -98 -311 9 -287 169 8 52 54 114 100 134 38 16 105 18 143 3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 1725 l0 -145 150 0 150 0 0 145 0 145 -150 0 -150 0 0 -145z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1130 1725 l0 -145 150 0 150 0 0 145 0 145 -150 0 -150 0 0 -145z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3690 1725 l0 -145 150 0 150 0 0 145 0 145 -150 0 -150 0 0 -145z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4220 1725 l0 -145 150 0 150 0 0 145 0 145 -150 0 -150 0 0 -145z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 1215 l0 -145 150 0 150 0 0 145 0 145 -150 0 -150 0 0 -145z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1130 1215 l0 -145 150 0 150 0 0 145 0 145 -150 0 -150 0 0 -145z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3690 1215 l0 -145 150 0 150 0 0 145 0 145 -150 0 -150 0 0 -145z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4220 1215 l0 -145 150 0 150 0 0 145 0 145 -150 0 -150 0 0 -145z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 700 l0 -150 150 0 150 0 0 150 0 150 -150 0 -150 0 0 -150z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1130 700 l0 -151 148 3 147 3 0 145 0 145 -147 3 -148 3 0 -151z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3694 837 c-2 -7 -3 -74 -2 -148 l3 -134 148 -3 147 -3 0 151 0 150 -145 0 c-110 0 -147 -3 -151 -13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4220 700 l0 -150 150 0 150 0 0 150 0 150 -150 0 -150 0 0 -150z"
}));

function SvgSchool1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool1);
export default __webpack_public_path__ + "static/media/school-_1_.83cf6e8e.svg";
export { ForwardRef as ReactComponent };